//all main method
import Vue from 'vue';
import axios from 'axios';
import AxiosPlugin from 'vue-axios-cors';
import horoscope_icon from '../horoscope_sign.json';
const proxyurl = "https://corsanywhere.herokuapp.com/";
const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
const horoscopeURL = "https://zodiacal.herokuapp.com/";
const tarotURL = "https://rws-cards-api.herokuapp.com/api/v1/cards";
const DB_API = 'http://cook.grabmobi.com/api/contents/mobiscope_content?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6';
const API_GET_ALL_MOBISCOPE = 'http://cook.grabmobi.com/api/contents/allmobiscope_content?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6';
let currentDate = new Date();
let year = currentDate.getFullYear();
const horo = require("horoscope");
const host = window.location.host;
const parts = host.split(".");

Vue.use(AxiosPlugin);

export default new Vue({
data(){
  return{
    //for horoscope.vue
    horoscopeData: {
      data: {},
      horosign: "",
      horoscopeMonth: {}
    },
    //for tarot.vue
    tarotData:{
      data: {},
      majors: {},
      wands: {},
      swords: {},
      cups: {},
      pentacles: {},
      tarots: {},
      loading: true,
    },
    //for zodiac.vue
    zodiacData:{
      zodiacs: {},
      elements: {},
    },
    //load page
    loadingPage:{
      loading: true,
    },
    country: parts[0]
  }
},
created(){
  if(host.includes("mobiscope")){
    this.getHorosign()
    this.getCards()
    // this.getZodiac()
    // this.getElements()
  }
},
methods:{
  async getHorosign() {
    let importData = []

    horoscope_icon.horoscope.map((item)=>{
      item.icon = require(`../../../assets/mobiscope/imgs/horoscope_icon/${item.icon}`)
    })

    importData = horoscope_icon.horoscope
    //insert into data
    this.horoscopeData.data = importData;

    let mon = currentDate.getUTCMonth()+1
    mon = '0'+ mon

    let horo_date = `${year}-${mon}-${currentDate.getUTCDate()}`;
    let sign = horo.getSign({month: currentDate.getUTCMonth()+1, day: currentDate.getUTCDate() })
    let signs = sign
    
    await axios.get(`${DB_API}&horoscope=${signs}&date=${horo_date}`).then((res)=>{
      let data = res.data.data[0]
      data.image = require(`../../../assets/mobiscope/imgs/zodiac_image/${data.horoscope_sign}.svg`);
      this.loadingPage.loading = false;
      this.horoscopeData.horosign = data.horoscope_sign
      this.horoscopeData.horoscopeMonth = data

    }).catch((err) => {
      console.error(err);
    })
  },
  getCards(){
    let major = [];
    let wand = [];
    let sword = [];
    let cup = [];
    let pentacle = [];

    const card = {
      url: proxyurl + tarotURL,
      method: 'GET'
    }

    this.$axios(card).then((res) => { 
      this.tarotData.loading = false;
      let response = res.data; 
      let tarot = response.cards;
       console.log(tarot);
      //to divide by type
      tarot.map((value)=>{  
        if (value.type == "major") {
          major.push(value);
        } else if (value.type == "minor") {
          if (value.suit == "wands") {
            wand.push(value);
          } else if (value.suit == "cups") {
            cup.push(value);
          } else if (value.suit == "swords") {
            sword.push(value);
          } else if (value.suit == "pentacles") {
            pentacle.push(value);
          }
        }
      });

      //show image in slider
      for (let i = 0; i < major.length; i++) {
        major[i].image = require(`../../../assets/mobiscope/imgs/tarot_image/${major[i].name}.jpg`);

        //change name
        if (major[i].name == "Fortitude") {
          major[i].name = "Strength(Fortitude)";
        }

        this.tarotData.data = tarot;
        this.tarotData.majors = major;
        this.tarotData.wands = wand;
        this.tarotData.cups = cup;
        this.tarotData.swords = sword;
        this.tarotData.pentacles = pentacle;
        
      }
    })
    .catch((err) => {
      // console.error(err);
    })
  },
  getZodiac() {
    const zodiac = {
      url: proxyurl + horoscopeURL + "api",
      method: 'GET'
    } 
    this.$axios(zodiac).then((res) => { 
      var response = JSON.parse(res.data);
      this.loadingPage.loading = false;
      this.zodiacData.zodiacs = response.data;

      let data = this.zodiacData.zodiacs
      data.sort(function(a,b){
        //to sort zodiacs based on date
        let date1 = new Date(a.sun_dates[0]);
        let date2 = new Date(b.sun_dates[0]);

        return date1 - date2
      })
      
      //change month to short
      for (let i = 0; i < data.length; i++) {
        var first = new Date(data[i].sun_dates[0]  + ", " + year);
        var last = new Date(data[i].sun_dates[1]  + ", " + year);
        let date = months[first.getUTCMonth()]+" "+(first.getUTCDate()+1)+" - "+months[last.getUTCMonth()]+" "+(last.getUTCDate()+1)
        data[i].date = date
        data[i].icon = require(`../../../assets/mobiscope/imgs/horoscope_icon/${data[i].name}.svg`);
      }
      this.zodiacData.zodiacs = data
    })
    .catch((err) => {
      // console.error(err);
    })
  },
  getElements() {
      const elements = {
        url: proxyurl + horoscopeURL + "elements",
        method: 'GET'
      }
      this.$axios(elements).then((res) => { 
        // this.loadingPage.loading = false;
         var response = JSON.parse(responses.data); 
          let data = response.data;

          data.sort(function(a,b){
            //to sort element based on name
            return a.element_name.localeCompare(b.element_name);
          })
          for(let i = 0; i<data.length; i++){
            if(data[i].element_name == 'Air'){
              data[i].element_nameAR = 'الهواء'
              data[i].element_nameGR = 'Αέρας'
              data[i].element_nameMY = 'Udara'
              data[i].element_nameTH = 'ลม'
            }else if(data[i].element_name == 'Water'){
              data[i].element_nameAR = 'الماء'
              data[i].element_nameGR = 'Νερό'
              data[i].element_nameMY = 'Air'
              data[i].element_nameTH = 'น้ำ'
            }else if(data[i].element_name == 'Fire'){
              data[i].element_nameAR = 'النار'
              data[i].element_nameGR = 'Φωτιά'
              data[i].element_nameMY = 'Api'
              data[i].element_nameTH = 'ไฟ'
            }else if(data[i].element_name == 'Earth'){
              data[i].element_nameAR = 'الارض'
              data[i].element_nameGR = 'Γη'
              data[i].element_nameMY = 'Bumi'
              data[i].element_nameTH = 'ดิน'
            }
          }

          for (let i = 0; i < data.length; i++) {
            data[i].icon = require(`../../../assets/mobiscope/imgs/elements/${data[i].element_name}.svg`);
          }

          setTimeout(()=>{
            this.zodiacData.elements = data
          }, 1000)
      })
      .catch((err) => {
        // console.error(err);
      })
    },
  }
})


// WEBPACK FOOTER //
// ./src/components/mobiscope/mobiscope-js/mobiscope.js